module.exports = __webpack_public_path__ + "img/Escape.ee6b12b1.png";